import React, {Component} from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import * as moment from "moment";
import NotificationSystem from "react-notification-system";
import {connect} from "react-redux";
import {style} from "variables/Variables.jsx";
import {isApiResponse, date_range_config} from '../helpers/utils.js';
import MultiCsvReportDownload from '../components/DownloadReport/MultiCsvReportDownload.jsx';
import MerchantFilter from '../filters/ServiceMerchantFilter.jsx';
import StoreFilter from '../filters/ServiceStoreFilter.jsx';
import DateRangeFilter from '../filters/DateRangeFilter.jsx';
import CityFilter from '../filters/ServiceCityFilter.jsx';
import ProductTypeFilter from '../filters/ServiceProductFilter.jsx';
import OpenTicketIssueSubCategory from '../filters/ServiceIssueSubCategory.jsx';
import ChannelNameFilter from '../filters/ChannelNameFilter.jsx';
import TeamNameFilter from '../filters/TeamNameFilter.jsx';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import MerchantTab from './PerTrendMerchantTab.jsx';
import StoreTab from './PerTrendStoreTab.jsx';
import IssueCategoryTab from './PerTrendIssueCategoryTab.jsx';
import ChannelTab from './PerTrendChannelTab.jsx';
import ProductTab from './PerTrendProductTab.jsx';
import CityTab from './PerTrendCityTab.jsx';
import TeamTab from './PerTrendTeamTab.jsx';
import MetricTab from './PerformanceTrendingMetricTab.jsx';

import LastRefresh from './LastRefresh.jsx';
// Date config for last 4 months
const diff = moment().diff(moment().subtract(4, 'months'), 'days');
var date_config = date_range_config(diff, '0', '2020-02-01','0');

class PerformanceTrendingReport extends Component{
    constructor(props) {
        super(props);
        this.state = {
            datefrom: date_config.start_date,
            dateTo: date_config.end_date,
            datefromShow: date_config.display_start_date,
            dateToShow: date_config.display_end_date,
            yestSend: date_config.start_date_value,
            todSend: date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit: date_config.end_date_limit,
            merchantID: '',
            chainID: '',
            storeID: '',
            merchantValue: null,
            chainValue: null,
            storeValue: [],
            ciutidIds: '',
            object_code: [],
            issue_type: "",
            cf_issue_sub_category: "",
            selected_tab: 'Merchant Name',
            isChange: false,
            ticket_id: '',
            cf_utid: '',
            beat_plan_date: null,
            model_visible: false,
            is_submit_disable: true,
            cf_merchant_contact_number: "",
            refreshKey: 0,
            cf_issue_sub_category: "",
            channel:"",
            city:"",
            team:"",
            product:"",
            shouldLoadData: false,
            isFilterVisible: false,
        }
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1: level = "success"; break;
            case 2: level = "warning"; break;
            case 3: level = "error"; break;
            case 4: level = "info"; break;
            default: break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (<div>{msg}</div>),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        if(decoded.object_type === 'Merchant'){
            this.setState({merchantID: arrayCode})
        }
        if(decoded.object_type === 'Chain'){
            this.setState({chainID: arrayCode})
        }
        if(decoded.object_type === 'Store'){
            this.setState({storeID: arrayCode})
        }

        this.setState({
            user_id: decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
            email: decoded.email
        });
    }

    componentDidMount() {
        this.setState({
            _notificationSystem: this.refs.notificationSystem,
            refreshKey: this.state.refreshKey + 1,
            shouldLoadData: true
        });

        // Add CSS for filter panel animation
        const style = document.createElement('style');
        style.innerHTML = `
        .filter-panel {
            max-height: 0 !important;
            overflow: hidden !important;
            opacity: 0 !important;
            transition: all 0.4s ease-in-out !important;
            padding: 0 !important;
            margin: 0 !important;
            display: block !important;
            height: 0 !important;
            visibility: hidden !important;
        }

        .filter-panel.show {
            max-height: 800px !important;
            opacity: 1 !important;
            padding: 10px 0 !important;
            margin: -10px 10 !important;
            height: auto !important;
            visibility: visible !important;
            overflow: visible !important;
        }

        .filter-panel.hide {
            max-height: 0 !important;
            opacity: 0 !important;
            padding: 0 !important;
            margin: 0 !important;
            height: 0 !important;
            visibility: hidden !important;
            overflow: hidden !important;
        }

        .filter-panel .col-md-2,
        .filter-panel .col-md-5 {
            transition: all 0.4s ease-in-out !important;
        }
        `;
        document.head.appendChild(style);
    }

    TicketDownloadCheck(type, e){
        var fn = '';
        var url = '';
        var report_code = '';
        var group_by = ''

        if(type==='Merchant Name'){
            fn='performance_trending_merchant_wise.csv.gz';
            url = '/service_reports/performance_trending';
            report_code = "performance_trending_merchant_wise"
            group_by = 'merchant'
        }
        if(type==='Store Name'){
            fn='performance_trending_store_wise.csv.gz';
            url = '/service_reports/performance_trending';
            report_code = "performance_trending_store_wise"
            group_by = 'store'
        }
        if(type==='Issue Category'){
            fn='performance_trending_issue_category_wise.csv.gz';
            url = '/service_reports/performance_trending';
            report_code = "performance_trending_issue_category_wise"
            group_by = 'issue_category'
        }
        if(type==='Channel'){
            fn='performance_trending_channel_wise.csv.gz';
            url = '/service_reports/performance_trending';
            report_code = "performance_trending_channel_wise"
            group_by = 'channel'
        }
        if(type==='Product'){
            fn='performance_trending_product_wise.csv.gz';
            url = '/service_reports/performance_trending';
            report_code = "performance_trending_product_wise"
            group_by = 'product'
        }
        if(type==='City'){
            fn='performance_trending_city_wise.csv.gz';
            url = '/service_reports/performance_trending';
            report_code = "performance_trending_city_wise"
            group_by = 'city'
        }
        if(type==='Team Name'){
            fn='performance_trending_team_wise.csv.gz';
            url = '/service_reports/performance_trending';
            report_code = "performance_trending_team_wise"
            group_by = 'team'
        }
        if(type==='Metric'){
            fn='performance_trending_metric.csv.gz';
            url = '/service_reports/performance_trending_metric';
            report_code = "performance_trending_metric"
            group_by = null  // No grouping for metric
        }

        let filters = {
            end_date: this.state.todSend,
            start_date: this.state.yestSend,
            download: 1,
            report_code: report_code,
            user_id: this.state.user_id,
            merchant: this.state.merchantID,
            chain: this.state.chainID,
            store: this.state.storeID,
            issue_category: this.state.cf_issue_sub_category,
            city: this.state.city,
            channel: this.state.channel,
            product: this.state.product,
            team: this.state.team,
            group_by: group_by
        }

        this.setState({
            filters: filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, url, fn, 190);
    }

    handleRefresh(type, e) {
        this.setState(
            {
                shouldLoadData: true,
            },
            () => {
                if (type === 'Merchant Name') {
                    this.refs.merchantTabRef.get_filtered_performance_trending_merchant();
                }
                if (type === 'Store Name') {
                    this.refs.storeTabRef.get_filtered_performance_trending_store();
                }
                if (type === 'Issue Category') {
                    this.refs.issue_categoryTabRef.get_filtered_performance_trending_issue_category();
                }
                if (type === 'Channel') {
                    this.refs.channelTabRef.get_filtered_performance_trending_channel();
                }
                if (type === 'Product') {
                    this.refs.productTabRef.get_filtered_performance_trending_product();
                }
                if (type === 'City') {
                    this.refs.cityTabRef.get_filtered_performance_trending_city();
                }
                if (type === 'Team Name') {
                    this.refs.teamTabRef.get_filtered_performance_trending_team();
                }
                if (type === 'Metric') {
                    this.refs.metricTabRef.get_filtered_performance_trending_metric();
                }
            }
        );
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(
            date_config.start_date,
            date_config.end_date,
            date_config.display_start_date,
            date_config.display_end_date,
            date_config.start_date_value,
            date_config.end_date_value
        );

        if(this.state.object_type === 'Innoviti') {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false, '');
        }
        if(this.state.object_type === 'Merchant') {
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code, false, '');
        }
        if(this.state.object_type === 'Chain') {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code, false, '');
        }

        this.refs.OpenTicketIssueSubCategoryFilter.restOpenTicketIssueSubCategoryFilter();
        this.refs.ChannelNameFilter.resetChannelFilter();
        this.refs.productTypeFilter.resetProductFilter();
        this.refs.cityFilter.resetCityFilter();
        this.refs.TeamNameFilter.resetTeamFilter();

        this.setState({
            datefrom: date_config.start_date,
            dateTo: date_config.end_date,
            datefromShow: date_config.display_start_date,
            dateToShow: date_config.display_end_date,
            yestSend: date_config.start_date_value,
            todSend: date_config.end_date_value,
            merchantID: '',
            chainID: '',
            storeID: '',
            storeValue: [],
            merchantValue: [],
            chainValue: [],
            ciutidIds: '',
            isChange: false,
            issue_type: "",
            cf_issue_sub_category: "",
            cf_merchant_contact_number: "",
            channel:"",
            city:"",
            team:"",
            product:"",
            refreshKey: this.state.refreshKey + 1,
            shouldLoadData: true
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }

    handleDateRange = (todSend, yestSend, datefromShow, dateToShow) => {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }

    handleMerchant = (optionSelected, merchantID) => {
        this.setState({
            merchantID: merchantID,
            isChange: true,
            chainID: '',
            storeID: '',
            ciutidIds: '',
        });
    }

    handleChain = (optionSelected, chainID) => {
        this.setState({
            chainID: chainID,
            isChange: true,
            storeID: '',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID, false, '');
    }

    handleStore = (storeID) => {
        this.setState({
            storeID: storeID,
            isChange: true,
            ciutidIds: '',
        });
    }

    handleOpenTicketIssueSubCategory = (optionSelected, cf_issue_sub_category) => {
        this.setState({
            cf_issue_sub_category: cf_issue_sub_category,
            isChange: true
        });
    }

    handleCity = (optionSelected, city) => {
        this.setState({
            city: city,
            isChange: true
        });
    }

    handleChannel = (optionSelected, channel) => {
        this.setState({
            channel: channel,
            isChange: true
        });
    }

    handleProduct = (optionSelected, product) => {
        this.setState({
            product: product,
            isChange: true
        });
    }

    handleTeam = (optionSelected, team) => {
        this.setState({
            team: team,
            isChange: true
        });
    }

    get_selected_tab(object_type, object_code, selected_tab, event){
        // Default to last 4 months for all tabs
        if (selected_tab === 'Metric') {
            const diff = moment().diff(moment().subtract(4, 'months'), 'days');
            const metric_date_config = date_range_config(diff, '0', '2020-02-01', '0');

            this.setState({
                selected_tab: selected_tab,
                yestSend: metric_date_config.start_date_value,
                todSend: metric_date_config.end_date_value,
                datefrom: metric_date_config.start_date,
                dateTo: metric_date_config.end_date,
                datefromShow: metric_date_config.display_start_date,
                dateToShow: metric_date_config.display_end_date,
                refreshKey: this.state.refreshKey + 1,
                shouldLoadData: true
            }, () => {
                // ✅ Update DateRangeFilter UI component
                this.refs.daterangeFilter.restDateFilter(
                    metric_date_config.start_date,
                    metric_date_config.end_date,
                    metric_date_config.display_start_date,
                    metric_date_config.display_end_date,
                    metric_date_config.start_date_value,
                    metric_date_config.end_date_value
                );
            });
        } else {
            // For all other tabs, use last 4 months
            const diff = moment().diff(moment().subtract(4, 'months'), 'days');
            const default_date_config = date_range_config(diff, '0', '2020-02-01', '0');

            this.setState({
                selected_tab: selected_tab,
                yestSend: default_date_config.start_date_value,
                todSend: default_date_config.end_date_value,
                datefrom: default_date_config.start_date,
                dateTo: default_date_config.end_date,
                datefromShow: default_date_config.display_start_date,
                dateToShow: default_date_config.display_end_date,
                refreshKey: this.state.refreshKey + 1,
                shouldLoadData: true
            }, () => {
                // ✅ Update DateRangeFilter UI component
                this.refs.daterangeFilter.restDateFilter(
                    default_date_config.start_date,
                    default_date_config.end_date,
                    default_date_config.display_start_date,
                    default_date_config.display_end_date,
                    default_date_config.start_date_value,
                    default_date_config.end_date_value
                );
            });
        }
    }

    handleApplyFilters = () => {
        this.setState({
            isChange: false,
            refreshKey: this.state.refreshKey + 1,
            shouldLoadData: true
        });
    }

    toggleFilterPanel = () => {
        this.setState(prevState => ({
            isFilterVisible: !prevState.isFilterVisible
        }));
    }

    render() {
        console.log('Parent render - shouldLoadData:', this.state.shouldLoadData)
        return(
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title service-title">Performance Trending Report</h4>
                                        <p className="category"></p>
                                        <LastRefresh />
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        <div className="report-header-icons">
                                            <div className="icon-button filter-icon" title="Filter Report"
                                              onClick={this.toggleFilterPanel}>
                                                <i className="fa fa-filter"></i>
                                            </div>
                                            <div className="icon-button refresh-icon" title="Refresh Report"
                                              onClick={this.handleRefresh.bind(this, this.state.selected_tab)}>
                                                <i className="fa fa-refresh"></i>
                                            </div>
                                            <div className="icon-button download-icon" title="Download Report"
                                              onClick={this.TicketDownloadCheck.bind(this, this.state.selected_tab)}>
                                                <i className="fa fa-download"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className = "clearfix"></div>

                                <div className="content-service">
                                    <div className="">
                                        <div className={`col-md-12 filter-panel ${this.state.isFilterVisible ? 'show' : 'hide'}`}>
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label>Ticket Logged In Date: </label></div>
                                                <DateRangeFilter
                                                    ref="daterangeFilter"
                                                    onSelectDate = {this.handleDateRange}
                                                    start_date = {this.state.datefrom}
                                                    end_date={this.state.dateTo}
                                                    display_start_date = {this.state.datefromShow}
                                                    display_end_date = {this.state.dateToShow}
                                                    start_date_limit = {this.state.dateFromLimit}
                                                />
                                            </div>

                                            {this.state.object_type === 'Innoviti' ?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter
                                                        ref="merchantFilter"
                                                        onSelectMerchant = {this.handleMerchant}
                                                        object_type = {this.state.object_type}
                                                        object_code={this.state.object_code}
                                                        user_type = {this.state.userType}
                                                    />
                                                    <div className="clearfix"></div>
                                                </div> : null}

                                            {this.state.object_type === 'Innoviti' || this.state.object_type === 'Merchant' ?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Issue Category </label>
                                                    <OpenTicketIssueSubCategory
                                                        ref="OpenTicketIssueSubCategoryFilter"
                                                        onSelectOpenTicketIssueSubCategory = {this.handleOpenTicketIssueSubCategory}
                                                    />
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> City: </label>
                                                <CityFilter ref="cityFilter" onSelectCity = {this.handleCity}/>
                                                <div className="clearfix"></div>
                                            </div>

                                            {this.state.object_type === 'Innoviti' || this.state.object_type === 'Merchant' || this.state.object_type === 'Chain' || this.state.object_type === 'Store' ?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter
                                                        ref= "reloadStore"
                                                        onSelectStore = {this.handleStore}
                                                        object_type = {this.state.object_type}
                                                        object_code={this.state.object_code}
                                                        user_type = {this.state.userType}
                                                    />
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Team Name</label>
                                                <TeamNameFilter ref="TeamNameFilter" onSelectTeam = {this.handleTeam} />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Channel</label>
                                                <ChannelNameFilter ref="ChannelNameFilter" onSelectChannel = {this.handleChannel} />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Product Type </label>
                                                <ProductTypeFilter
                                                    ref="productTypeFilter"
                                                    onSelectProduct = {this.handleProduct}
                                                    userType={this.state.userType}
                                                />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-5 pull-right marginTop">
                                                <button type="button" className="primary apply-filter" role="button" onClick={this.handleApplyFilters}>Apply</button>
                                                &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button" onClick={this.reset_all.bind(this)}>Reset</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row"></div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep-service-pages"></div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <Tabs>
                                            <TabList>
                                                {this.state.object_type === 'Innoviti' ?
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Merchant Name','')}>Merchant Name</Tab> :
                                                null}
                                                {this.state.object_type !== 'Innoviti' ?
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Store Name','')}>Store Name</Tab>:
                                                null}
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Issue Category','')}>Issue Category</Tab>
                                                {this.state.object_type === 'Innoviti' ?
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Team Name','')}>Team Name</Tab>:
                                                null}
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Channel','')}>Channel</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Product','')}>Product</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'City','')}>City</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Metric','')}>Metric</Tab>
                                            </TabList>

                                            {this.state.object_type === 'Innoviti' ?
                                            <TabPanel>
                                                <MerchantTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="merchantTabRef"
                                                />
                                            </TabPanel> : null}

                                            {this.state.object_type !== 'Innoviti' ?
                                            <TabPanel>
                                                <StoreTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="storeTabRef"
                                                />
                                            </TabPanel>: null}

                                            <TabPanel>
                                                <IssueCategoryTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="issue_categoryTabRef"
                                                />
                                            </TabPanel>

                                            {this.state.object_type === 'Innoviti' ?
                                             <TabPanel>
                                                 <TeamTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="teamTabRef"
                                                />
                                            </TabPanel>: null}

                                            <TabPanel>
                                                <ChannelTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="channelTabRef"
                                                />
                                            </TabPanel>

                                            <TabPanel>
                                                <ProductTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="productTabRef"
                                                />
                                            </TabPanel>

                                            <TabPanel>
                                                <CityTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="cityTabRef"
                                                />
                                            </TabPanel>

                                            <TabPanel>
                                                <MetricTab
                                                    key={this.state.refreshKey}
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    city={this.state.city}
                                                    channel={this.state.channel}
                                                    product={this.state.product}
                                                    team={this.state.team}
                                                    user_id={this.state.user_id}
                                                    shouldLoadData={this.state.shouldLoadData}
                                                    onDataLoaded={() => this.setState({ shouldLoadData: false })}
                                                    ref="metricTabRef"
                                                />
                                            </TabPanel>
                                        </Tabs>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => {dispatch({type:'change_menu',payload:name})}
    }
}

export default connect(null, mapDispatchToProps)(PerformanceTrendingReport);